import { create } from "zustand";
import moment from "moment-timezone";

export const DEFAULT_TIME_ZONE = "UTC";

/** Rejects invalid cookie values before they reach date formatters. */
const validTimeZone = (value) => (moment.tz.zone(value || "") ? value : DEFAULT_TIME_ZONE);

/** Restores the preference without relying on the browser's timezone. */
const getInitialTimeZone = () => {
  try {
    const cookie = document.cookie.split("; ").find((entry) => entry.startsWith("timeZone="));
    return validTimeZone(cookie && decodeURIComponent(cookie.slice("timeZone=".length)));
  } catch {
    return DEFAULT_TIME_ZONE;
  }
};

export const useTimeZoneStore = create((set) => ({
  timeZone: getInitialTimeZone(),
  /** Applies immediately and remembers the preference for one year on this portal. */
  setTimeZone: (value) => {
    const timeZone = validTimeZone(value);
    try {
      const secure = window.location.protocol === "https:" ? "; Secure" : "";
      document.cookie = `timeZone=${encodeURIComponent(
        timeZone
      )}; Path=/; Max-Age=31536000; SameSite=Lax${secure}`;
    } catch {
      // The selection still works if the browser blocks cookies.
    }
    set({ timeZone });
  },
}));

/** Exposes the preference to formatters outside React components. */
export const getTimeZone = () => useTimeZoneStore.getState().timeZone;

export const timeZoneOptions = [
  DEFAULT_TIME_ZONE,
  ...moment.tz.names().filter((zone) => zone !== DEFAULT_TIME_ZONE),
].map((value) => ({ value, label: value.replace(/_/g, " ") }));
